import Vue from "vue";

const state = {
	activeCheckboxes: [],
	countCurrentChecks: 0,
	showModal: false,
	checklistType: ""
};

const getters = {
	activeCheckboxes: state => {
		if (localStorage.getItem('bostadskund-checklist')) {
			const checkList = JSON.parse(localStorage.getItem('bostadskund-checklist'));
			return checkList.length;
		} else {
			return 0;
		}
	},
	countCurrentChecks: state => {
		return state.countCurrentChecks;
	},
	showModal: state => {
		return state.showModal;
	},
	checklistType: state => {
		return state.checklistType;
	}
};

const mutations = {
	setChecklistType: (state, checklistType) => {
		Vue.set(state, "checklistType", checklistType);
	},
	setCountCurrentChecks: (state, countCurrentChecks) => {
		Vue.set(state, "countCurrentChecks", countCurrentChecks);
	},
	setShowModal: (state, modalId) => {
		if (modalId) {
			Vue.set(state, "showModal", modalId);
			clearTimeout(state.showModal);
			setTimeout(() => {
				state.showModal = true;
			}, 5000);
		} else if (!modalId) {
			Vue.set(state, "showModal", false);
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations
};
